//发起人用户信息
export default {
  props: {
    labelTitle: {
      type: String,
      default: ''
    },
    userInfo:{
      type: Object,
      default: ()=>{
        return {}
      }
    },
  },
  data() {
    return {
      cardCount: '',
    }
  },
  computed: {
    isReplacement() {
      return this.labelTitle === '补卡理由'
    }
  },
  methods: {
    getRepairCount() {
      if (!this.isReplacement) {
        return
      }

      if (this.mode === 'DESIGN') {
        this.cardCount = 0
        return
      }

      const userId = this.userInfo.id || sessionStorage.getItem('user_id')
      this.$api.userRepairCount({ userId }).then((res) => {
        if (res.code === 0) {
          this.cardCount = res.data
        }
      })
    },
  },
  mounted() {
    this.getRepairCount()
  },
}
